//src/rtkQuery/features/hooks/useTestimonialsService.ts
import {
  useGetTestimonialsQuery,
  useLazyGetTestimonialsQuery,
  useSubmitTestimonialMutation,
} from '../services/testimonials';

export const useTestimonialsService = () => {
  const {
    data: testimonials,
    isLoading,
    isError,
    isSuccess,
    error,
    refetch,
  } = useGetTestimonialsQuery();

  const [
    trigger,
    {
      data: lazyTestimonials,
      isLoading: lazyLoading,
      isError: lazyError,
      isSuccess: lazySuccess,
      error: lazyErr,
    }, 
  ] = useLazyGetTestimonialsQuery();

  const [
    submitTestimonial,
    {
      data: submitResponse,
      isLoading: submitting,
      isError: submitError,
      isSuccess: submitSuccess,
      error: submitErr,
    },
  ] = useSubmitTestimonialMutation();

  return {
    testimonialData:testimonials,
    testimonialIsLoading:isLoading,
    testimonialIsError:isError,
    testimonialIsSuccess:isSuccess,
    testimonialError:error,
    testimonialRefresh:refetch,

    fetchTestimonials: trigger,
    testimonialLazyTestimonials:lazyTestimonials,
    testimonialLazyLoading:lazyLoading,
    testimonialLazyError:lazyError,
    testimonialLazySuccess:lazySuccess,
    testimonialLazyErr:lazyErr,

    submitTestimonial,
    submitResponse,
    submitting,
    submitError,
    submitSuccess,
    submitErr,
  };
};
